import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_8r.png",
      alt: "Estratégias 8R",
    },
    title: "8r",

    // String ou array de strings
    text: "O 8remoras são Algoritmos completo para análise e monitoramento de indicadores do mercado financeiro. Os algoritmos oferecem uma ampla gama de ferramentas e recursos que permitem aos seus clientes.",
    testimonial: {
      text: "Compromisso com a Qualidade",
      // author: {
      // name: "Bruno Ramos, CEO e estrategista-chefe da trade2go",
      // picture:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      // },
    },
  },

  strategies: {
    title: "Algoritmos da 8remora",
    heading: "Ter mais tranquilidade e segurança",
    subtitle:
      "O robô oferece a você a tranquilidade de saber que seus investimentos estão sendo gerenciados por profissionais experientes.",
  },

  cta: {
    title: "Invista com segurança e inteligência com a 8remora",
    subtitle: "Assine 8remora",
    buttonText: "Ativar extensão",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "A 8remoras",
    col1: [
      "A 8remoras é uma empresa de tecnologia que fornece soluções inovadoras para análise e monitoramento de indicadores do mercado financeiro. Com mais de 6 anos de experiência, a empresa oferece uma plataforma robusta e intuitiva que permite aos seus clientes tomar decisões mais assertivas e inteligentes. A 8remoras se destaca pela sua equipe altamente qualificada, pelo seu compromisso com a qualidade e pela sua constante busca por inovações.",
    ],
    // col2: [
    //   "",
    // ],
  },

  stats: {
    title: "Alguns números da 8r",
    subtitle: "Desempenho, segurança e tecnologia",
    data: [
      {
        value: "+1.5k",
        description: "Horas de validação",
      },
      {
        value: "+200",
        description: "Estratégias testadas",
      },
      {
        value: "+15k",
        description: "Linhas de código proprietário",
      },
      {
        value: "+5",
        description: "Anos desenvolvendo portfólios",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Por que utilizar os robôs da trade2go?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description: "Confira seu potencial.",
      },
      {
        icon: iconsSet.clock,
        title: "Nosso robô pode:",
        description:
          "Analisar o mercado financeiro 24 horas por dia, 7 dias por semana: Ele identifica as melhores oportunidades de investimento e realiza as operações automaticamente, para que você não precise se preocupar com nada.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description: "Você só precisa assinar e deixar o robô investir para você.",
      },
      {
        icon: iconsSet.hourglass,
        title: "Com o nosso robô, você pode:",
        description:
          "Ganhar dinheiro enquanto você dorme: O robô trabalha para você 24 horas por dia, para que você possa aproveitar seu tempo livre sem se preocupar com a renda. ",
      },
      {
        icon: iconsSet.cloud,
        title: "Praticidade",
        description: "Não é preciso instalar nada nem ser expert: tudo é executado em nuvem.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte",
        description: "Nossa equipe está à disposição para tirar suas dúvidas sobre as estratégias e planos.",
      },
      // ...defaultContent.features.data,
    ],
  },

  // testimonials: [
  //   {
  //     text: "Tenho recomendado a trade2go a todos os amigos e familiares. Os resultados incríveis que obtive superaram minhas expectativas, sem falar no suporte excepcional da equipe que faz toda a diferença. Recomendo demais para quem busca sucesso no mercado financeiro.",
  //     author: "Alexandre Melara",
  //     job: "Consultor",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
  //   },
  //   {
  //     text: "Graças às estratégias da trade2go, finalmente encontrei uma forma de potencializar meus investimentos com minicontratos eliminando o aspecto emocional.",
  //     author: "Ricardo Silva",
  //     job: "Administrador de Empresas",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
  //   },
  // ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
